/**
 * Extracts mention UUIDs from HTML content generated by TipTap.
 * Matches <span data-type="mention" data-id="UUID">...</span> tags.
 * 
 * @param htmlContent The HTML content from the editor.
 * @returns An array of unique UUIDs from mentions.
 */
export const extractMentionIds = (htmlContent: string): string[] => {
  if (!htmlContent) return [];
  
  // Regex matches <span [any attributes] data-type="mention" [any attributes] data-id="some-uuid"
  const regex = /<span [^>]*data-type="mention"[^>]*data-id="([^"]+)"/g;
  const ids = new Set<string>();
  let match;
  
  while ((match = regex.exec(htmlContent)) !== null) {
    if (match[1]) {
      ids.add(match[1]); 
    }
  }
  
  return Array.from(ids);
};
